import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { PendingDoc } from '../models/pending-doc';
import { MatTableDataSource } from '@angular/material/table';

@Injectable({
  providedIn: 'root'
})
export class PendingDocService {

  public documentDataSource: MatTableDataSource<any>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage) { }

  select() {
    return this.db.collection<PendingDoc>('sbccv_pendingdocs', ref => ref
      .orderBy('member_name', 'asc')).snapshotChanges();
  }

  selectSent() {
    return this.db.collection<PendingDoc>('sbccv_pendingdocs', ref => ref
      .where('pending', '==', true)
      .where('sent', '==', true)
      .orderBy('date', 'asc')).snapshotChanges();
  }


  delete(doc_id: any) {
    return this.db.collection('sbccv_pendingdocs').doc(doc_id).delete()
  }

  update(entity: PendingDoc) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_pendingdocs').doc(id).set(Object.assign({}, entity), { 'merge': true });
  }

  approved(id: any, approved: boolean) {

    if (approved) {
      return this.db.collection('sbccv_pendingdocs').doc(id).set(
        {
          'approved': true,
          'pending': false,
          'sent': false
        }, { 'merge': true }
      );
    } else {
      return this.db.collection('sbccv_pendingdocs').doc(id).set(
        {
          'approved': false,
          'pending': true,
          'sent': false
        },
        { 'merge': true }
      );
    }

  }

}



